import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Collapse from '@mui/material/Collapse'
import get from 'lodash/get'

import Markdown from '@components/markdown'
import PlusMinusIcon from '@components/icons/plusminus'
import styles from '@components/programmatic_blocks/research_category.module.scss'

const stopPropagation = e => {
  e.stopPropagation()
}

const Article = ({ article }) => {
  const { t } = useTranslation()

  const citation = get(article, 'fields.citation')
  const file = get(article, 'fields.article.fields.file.url')

  return (
    <div className={styles.article}>
      <div className={styles.article__citation}>
        <Markdown>{citation}</Markdown>
      </div>
      <div className={styles.article__file}>
        <a
          href={file}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stopPropagation}
          data-link-type="research-article"
          data-link-label={citation}
        >
          {t('download')}
        </a>
      </div>
    </div>
  )
}

const ResearchCategory = props => {
  const [expanded, setExpanded] = useState(false)

  const toggle = () => {
    setExpanded(!expanded)
  }

  const articles = props.articles.map((article, i) => <Article key={i} article={article} />)

  return (
    <div className={styles.researchCategory}>
      <div className={styles.researchCategory__header} onClick={toggle}>
        <div className={styles.researchCategory__name}>{props.name}</div>
        <PlusMinusIcon className={styles.researchCategory__icon} minus={expanded} />
      </div>
      <Collapse in={expanded}>{articles}</Collapse>
    </div>
  )
}

export default ResearchCategory
